const useStyles = theme => ({
    pageTitle: {
        width: '100%',
        textAlign: 'center',
    },
    mightyLogo: {
        [theme.breakpoints.up('md')]: {
            height: '140px',
        },
        [theme.breakpoints.down('sm')]: {
            width: '90%',
        },
    },
    mightyLogoLandscape: {
        [theme.breakpoints.up('md')]: {
            height: '140px',
        },
        [theme.breakpoints.down('sm')]: {
            maxWidth: '20%',
        },
    },
    chapterName: {
        textDecoration: 'underline',
        textUnderlineOffset: '10px',
        marginLeft: '15px',
        color: '#182C55',
        fontSize: '1.8em',
        fontFamily: "'League Gothic', sans-serif",
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            marginLeft: 0,
        },
    },
    chapterNameMobile: {
        textDecoration: 'underline',
        textUnderlineOffset: '10px',
        marginLeft: '15px',
        //marginTop: '20%',
        color: '#182C55',
        fontSize: '1.8em',
        fontFamily: "'League Gothic', sans-serif",
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            marginLeft: 0,
        },
    },
    gameDesc: {
        margin: '15px 0 15px 15px',
        color: '#182C55',
        fontFamily: '"Barlow", sans-serif',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            margin: '15px 0 15px 0px',
        },
    },
    howToPlay: {
        backgroundColor: '#182C55',
        color: 'white',
        padding: '8px 10px 8px 10px',
        margin: '1em',
        fontWeight: 'bold',
        cursor: 'pointer',
        border: '1px solid #182C55',
        borderRadius: '5px',
        fontFamily: '"League Gothic", sans-serif',
        position: 'fixed',
        right: '30px',
        fontSize: '1.2em',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    howToPlayMenu: {
        position: 'fixed',
        right: '30px',
        margin: '1em',
        width: '1.2em',
        cursor: 'pointer',
        color: '#182C55',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
        [theme.breakpoints.down('sm')]: {
            margin: 0,
            right: '10px',
            top: '10px',
        },
    },
    mightyFooter: {
        width: '100vw',
        marginLeft: '-24px',
        cursor: 'pointer',
        [theme.breakpoints.up('md')]: {
            position: 'fixed',
            bottom: 0,
        },
        [theme.breakpoints.down('md')]: {
            marginTop: '2em',
            marginBottom: '-1em',
        },
        [theme.breakpoints.down('xs')]: {
            marginLeft: '-10px',
        },
    },
    landingContainer: {
        [theme.breakpoints.up('md')]: {
            height: '20vh',
        },
    },
    landingP: {
        fontSize: '3em',
        fontWeight: 'bold',
        fontFamily: "'League Gothic', sans-serif",
        marginTop: '10%',
        [theme.breakpoints.down('sm')]: {
            marginTop: '20%',
        },
    },
    // How to Play
    dlContainer: {
        margin: '0 auto',
        padding: '0 4rem 4rem 4rem',
        width: '80vw',
    },
    dlContent: {
        padding: '0px 10px 0px 10px',
        marginBottom: '2em',
        fontFamily: '"Barlow", sans-serif',
        fontWeight: '600px',
    },
    dlTitle: {
        fontFamily: '"League Gothic", sans-serif',
        fontSize: '2em',
        textTransform: 'uppercase',
        letterSpacing: '2px', 
        textAlign: 'center',
        color: '#182D55',
        marginTop: '-10px',
        marginBottom: '1em',
    },
    dlImage: {
        width: '90%',
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    dlSumm: {
        fontFamily: '"Barlow", sans-serif',
        fontWeight: '600px',
        padding: '1em',
        background: '#182D55',
        marginBottom: '1em',
        cursor: 'pointer',
        outline: 'none',
        borderRadius: '0.3em',
        fontWeight: 'bold',
        color: '#fff',
        '&:hover': {
          background: '#657dab',
        },
    },
    dlClose: {
        color: '#182C55',
        width: '1.2em',
        cursor: 'pointer',
        float: 'right',
        margin: '10px',
    },
    errorDl: {
        margin: '1em',
        lineHeight: '2em',
        fontFamily: '"Barlow", sans-serif',
        fontWeight: 'bold',
        color: '#182C55',
    },
});

export default useStyles;